import * as Types from '../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type WorkerSuggestionsQueryVariables = {};


export type WorkerSuggestionsQuery = (
  { __typename?: 'Query' }
  & { workers: Array<(
    { __typename?: 'Worker' }
    & Pick<Types.Worker, '_id' | 'name' | 'lastName' | 'firstName' | 'department' | 'company' | 'annotation' | 'qBasic' | 'qTurbo' | 'qSupersport' | 'qNordschleife' | 'qMuLow' | 'qOffroad' | 'inactive'>
  )> }
);

export const WorkerSuggestionsDocument = gql`
    query WorkerSuggestions {
  workers {
    _id
    name
    lastName
    firstName
    department
    company
    annotation
    qBasic
    qTurbo
    qSupersport
    qNordschleife
    qMuLow
    qOffroad
    inactive
  }
}
    `;

    export function useWorkerSuggestionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WorkerSuggestionsQuery, WorkerSuggestionsQueryVariables>) {
      return ApolloReactHooks.useQuery<WorkerSuggestionsQuery, WorkerSuggestionsQueryVariables>(WorkerSuggestionsDocument, baseOptions);
    };
      export function useWorkerSuggestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkerSuggestionsQuery, WorkerSuggestionsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<WorkerSuggestionsQuery, WorkerSuggestionsQueryVariables>(WorkerSuggestionsDocument, baseOptions);
      };
      
export type WorkerSuggestionsQueryHookResult = ReturnType<typeof useWorkerSuggestionsQuery>;
export type WorkerSuggestionsQueryResult = ApolloReactCommon.QueryResult<WorkerSuggestionsQuery, WorkerSuggestionsQueryVariables>;